// export const BASE_URL = "http://localhost:3001/api";
// export const CDN_BASE_URL = "http://localhost:3001/";
export const CDN_BASE_URL = "https://api.testplus.online/"
export const BASE_URL = "https://api.testplus.online/api"
